import React from 'react'
import cx from 'classnames'
import { FormattedMessage } from 'sb-react-intl'

import Link from 'components/ui/Link/Link'
import { Grid, Cell } from 'components/_new/layout/grid'

import s from './Label.scss'


const QueueLabel = (props) => {
  const { className, message, isFree, linkProps, columns, size, onClick } = props

  const tag     = onClick ? 'a' : 'div'
  const isLink  = Boolean(linkProps)

  const labelClassName = cx(s.label, className, {
    [s.free]: isFree,
    [s.clickable]: onClick,
  })

  return (
    <Grid
      className={s.grid}
      columns={columns}
    >
      <Cell className={labelClassName} size={size}>
        {
          isLink ? (
            <Link
              className={s.link}
              title={message}
              customColor
              withHtmlTitle
              onClick={onClick}
              {...linkProps}
            />
          ) : (
            <FormattedMessage
              tag={tag}
              {...message}
              onClick={onClick}
            />
          )
        }
      </Cell>
    </Grid>
  )
}


export default QueueLabel
